import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TokenHelperService {
  private tokenSubject$ = new BehaviorSubject<string>('');
  private currentDocId$ = new BehaviorSubject<string | null>(null);
  private TAB_DOC_KEY = 'CURRENT_SIGNING_DOC_ID'; // session-scoped key

  private keyFor(docId?: string) {
    return docId ? `SIGNING_TOKEN_${docId}` : 'SIGNING_TOKEN';
  }

  setCurrentDocId(docId: string | null) {
    this.currentDocId$.next(docId);
    try { 
      if (docId) sessionStorage.setItem(this.TAB_DOC_KEY, docId);
      else sessionStorage.removeItem(this.TAB_DOC_KEY);
    } catch(e) { /* ignore */ }
    // persist as fallback (localStorage) for iOS reloads:
    try { if (docId) localStorage.setItem(this.TAB_DOC_KEY, docId); } catch(e) {console.warn(e);}
  }

  getCurrentDocId(): string | null {
    const v = this.currentDocId$.value;
    if (v) return v;
    // fallback read from session/local
    try {
      return sessionStorage.getItem(this.TAB_DOC_KEY) ?? localStorage.getItem(this.TAB_DOC_KEY);
    } catch(e) { return null; }
  }

  saveSigningPageToken(token: string, docId?: string) {
    const key = this.keyFor(docId);
    try { sessionStorage.setItem(key, token); } catch(e) {console.warn(e);}
    try { localStorage.setItem(key, token); } catch(e) {console.warn(e);}
    this.tokenSubject$.next(token);
    if (docId) this.setCurrentDocId(docId);
  }

  getSigningPagetoken(docId?: string): string | null {
    const key = this.keyFor(docId ?? this.getCurrentDocId() ?? undefined);
    try {
      return sessionStorage.getItem(key) ?? localStorage.getItem(key);
    } catch(e) { return null; }
  }

  // optional observable if you want to wait for docId/token
  currentDocIdObservable() { return this.currentDocId$.asObservable(); }
}

